<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">导出异常行为识别结果</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>
        
        <div class="table-section">
                <el-table :data="tableData" style="width: 100%" :show-header="true" border class="analysis-table">
                    <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                    </el-table-column>
                    <el-table-column prop="sectionName" label="标段名称" align="center" header-align="center"
                        min-width="200">
                    </el-table-column>
                    <el-table-column prop="sectionCode" label="标段编号" align="center" header-align="center"
                        min-width="200">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" align="center" header-align="center" width="300">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleExport(scope.row)"
                                style="margin-right: 10px;">
                                导出
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { getSectionInfoByProjectCode } from '@/api/modules/base'
import { baseUrl } from '@/utils/base.js'
import axios from 'axios'
import Cookies from 'js-cookie'
export default {
    name: 'ExportBidAnalysis',
    data() {
        return {
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            tableData: [
            ],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            jumpPage: 1
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getSectionInfoByProjectCode()

    },
    methods: {
        //  获取标段列表
        getSectionInfoByProjectCode() {
            getSectionInfoByProjectCode(this.projectCode).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.map((item, index) => ({
                        no: index + 1,
                        sectionCode: item.sectionCode,
                        sectionName: item.sectionName,
                    }))
                } else {
                    this.$message.error(res.msg || '获取标段信息失败')
                }
            }).catch(error => {
                console.error('获取标段信息失败:', error)
                this.$message.error('获取标段信息失败')
            })
        },

        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 导出按钮点击
        handleExport(row) {
            this.exportAnomalousAnalysis(row.sectionCode)
        },
        exportAnomalousAnalysis(sectionCode) {
            axios({
                method: 'get',
                url: `/api/common/anomalous/export?sectionCode=${sectionCode}`,
                responseType: 'blob',
                baseURL: baseUrl,
                headers: {
                    Authorization: 'Bearer ' + Cookies.get('token')
                }
            }).then(response => {
                const blob = response.data
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.style.display = 'none'
                const fileName = `异常行为识别结果${sectionCode}_${new Date().getTime()}.xlsx`
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
                setTimeout(() => {
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)
                }, 100)

                this.$message.success('导出成功')
            }).catch(error => {
                console.error('导出失败:', error)
                this.$message.error('导出失败，请重试')
            })
        },

    

     

    
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.agent-page {
    .main-content {
        margin-top: 20px;
        overflow: hidden;

        .table-container {
            .analysis-table {
                .el-table__header {
                    th {
                        background-color: #f8fafc;
                        color: #64748b;
                        font-weight: 500;
                        border-color: #e2e8f0;
                    }
                }

                .el-table__body {
                    td {
                        color: #1f2937;
                        border-color: #e2e8f0;
                    }
                }
            }

            .pagination-section {
                display: flex;
                justify-content: flex-end;
                border-radius: 8px;
            }
        }
    }
}
</style>
